<!-- Button -->
<button
    mat-icon-button
    [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img
            class="w-7 h-7 rounded-full"
            *ngIf="showAvatar && user.avatar"
            [src]="user.avatar">

        <i *ngIf="!showAvatar || !user.avatar"
           class="far fa-lg fa-user-circle"></i>
    </span>
</button>

<mat-menu
    [xPosition]="'before'"
    #userActions="matMenu">
    <button mat-menu-item>
        <span class="flex flex-col leading-none">
            <span>Přihlášen jako</span>
            <span class="mt-1.5 text-md font-medium">{{user.email}}</span>
        </span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item
            (click)="userProfile()">
        <i class="far mr-2 fa-user-circle"></i>
        <span>Profil</span>
    </button>
<!--    <button mat-menu-item-->
<!--            (click)="credit()">-->
<!--        <i class="far fa-credit-card mr-2"></i>-->
<!--        <span>Dobít kredit</span>-->
<!--    </button>-->
    <button mat-menu-item
            (click)="settings()">
        <i class="far mr-2 fa-cog"></i>
        <span>Nastavení</span>
    </button>
    <mat-divider class="my-2"></mat-divider>
    <button
        mat-menu-item
        (click)="signOut()">
        <i class="far mr-2 fa-sign-out-alt"></i>
        <span>Odhlásit se</span>
    </button>
</mat-menu>

